export default {
  UPDATE_OUTREACH_MESSAGE_COUNT: 'UPDATE_OUTREACH_MESSAGE_COUNT',
}
